// Global settings file
const parameters = require('./build-parameters.json');

var appSettings = {
  defaultLocale: parameters.defaultLocale,
  url: parameters.baseUrl,
  COMMAND_DELAY: 100,
  connectedDevices: parameters.connectedDevices,
  paymentGateway: parameters.paymentGateway,
  locationTracking: parameters.locationTracking,
  whiteLabelled: parameters.whiteLabelled
}

export default appSettings;
